export const COTACAO_OBRA_TITLE = "Cotação da Obra";
export const COTACAO_OBRA_TEXTO =
  "Vale para todos os escopos e Facilidades desta Obra. Para alterar, use a Cotação da Obra no Planejamento e Controle.";
export const PROJECAO_SECAO = "Projeção financeira";
export const SERVICOS_TITLE = "Serviços";
export const MATERIAIS_TITLE = "Materiais";
export const VALOR_LABEL = (categoria: string) => `Valor Projetado para ${categoria}`;
export const MOEDA_LABEL = "Moeda";
export const DISTRIBUICAO_LABEL = (categoria: string) => `Distribuição por coletor (${categoria})`;
export const CURVA_LABEL = (categoria: string) => `Curva Mensalização (${categoria})`;
export const SELECIONE_PLACEHOLDER = "Selecione…";
export const TOTAL_ESCOPO_LABEL = "Valor total do escopo macro";
export const PENDENTE_COTACAO =
  "Pendente de cotação. O valor fica na moeda original, fora dos totais.";
export const DEFINIR_COTACAO_LABEL = "Definir cotação";
export const EDITAR_COTACAO_LABEL = "Editar cotação";
export const CONVERSAO_TEXTO = (valor: string, moeda: string) =>
  `= ${valor} (com o ${moeda} da Obra)`;
export const VALOR_OBRIGATORIO = "Informe um valor maior que zero.";
export const VALOR_MAXIMO = "O valor deve ser de no máximo 100.000.000.000.";
export const MATERIAIS_TODOS_OU_NENHUM =
  "Materiais leva valor, moeda, distribuição e curva, ou nenhum deles.";
export const FATOR_OBRIGATORIO = "Informe o fator de idade.";
export const FATOR_FORA_DA_FAIXA = "O fator de idade deve estar entre 0 e 100.";
/** Figma 13003:1058436. */
export const SEM_CUSTO_PADRAO_TITLE = "Sem custo padrão cadastrado para este escopo.";
export const SEM_CUSTO_PADRAO_TEXTO =
  "Manutenção Corretiva, itens em texto livre e equipamentos sem valor no ano não têm régua nem variação.";
/** Figma 17149:465580. */
export const USAR_CUSTO_PADRAO_LABEL = "Usar custos padrão para projetar";
export const CUSTO_PADRAO_APLICADO = (ano: number | null) =>
  ano === null ? "Custo padrão aplicado" : `Custo padrão ${ano} aplicado`;
export const EM_USO_TAG = "Em uso";
export const VARIACAO_CUSTO_PADRAO = (variacao: string) => `${variacao} vs custo padrão`;
export const VOLTAR_CONFIGURACAO_LABEL = "Voltar à configuração original";
/** Figma 13003:1058436 e 16419:429002. */
export const FATOR_TITLE = "Fator de idade da embarcação";
export const FATOR_APLICAR_LABEL = "Aplicar";
export const FATOR_CAMPO_LABEL = "Fator de idade (%)";
export const FATOR_COM_IDADE = (embarcacao: string, idade: number) =>
  `${embarcacao} tem ${idade} anos: +${idade}% sobre o valor projetado`;
export const FATOR_SEM_IDADE = (embarcacao: string) =>
  `${embarcacao} não tem idade cadastrada: informe o fator de idade sobre o valor projetado. Ele vale só para esta Obra.`;
export const CLASSIFICACAO_TITLE = "Classificação do Financeiro desse Escopo Macro";
export const CLASSIFICACAO_PENDENTE_TAG = "Classificação pendente";
export const CLASSIFICACAO_PLACEHOLDER = "Selecione…";
export const CARREGANDO_LABEL = "Carregando as opções da projeção…";
